import { render, staticRenderFns } from "./PageThree.vue?vue&type=template&id=0bcf579f&scoped=true&"
import script from "./PageThree.vue?vue&type=script&lang=js&"
export * from "./PageThree.vue?vue&type=script&lang=js&"
import style0 from "./PageThree.vue?vue&type=style&index=0&id=0bcf579f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcf579f",
  null
  
)

export default component.exports